import React from "react";
import { useSelector } from "react-redux";
import { selectAllFormSettings } from "../../../redux/slices/formSettingsSlice";
import { selectAlias } from "../../../redux/slices/p2pSettingsSlice";
import { selectHTTP } from "../../../redux/slices/configSlice";

import EventProfileImage from "./EventProfileImage";

const ConnectedEventProfileImage = () => {
    const HTTP_HOST = useSelector(selectHTTP);
    const formSettings = useSelector(selectAllFormSettings);
    const {
        theme: {
            header: { avatar = "", show_event_avatar = 1 },
        },
    } = formSettings;

    const alias = useSelector(selectAlias);

    const displayAvatar = !!(avatar && show_event_avatar);

    const eventProfileImageProps = {
        avatar,
        displayAvatar,
        eventHomeUrl: `${HTTP_HOST}/event/${alias}`,
    };

    return displayAvatar ? (
        <EventProfileImage {...eventProfileImageProps} />
    ) : null;
};

export default ConnectedEventProfileImage;
